import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import Box from "./Box";

const styles = {
  content: {
    textAlign: "center"
  }
};

const InfographicBox = props => (
  <Box reference={props.reference} backgroundColor="white">
    <h4 className="figure-title-only">{props.title}</h4>
    <div className={props.classes.content}>{props.children}</div>
  </Box>
);

InfographicBox.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(InfographicBox);
